import React from "react";

import { Gallery } from "../components/Gallery";

export const HomePage = () => {
  return <Gallery filter="watercolor" />;
};
